import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { QuestionsProps } from './Questions.tsx';

// The Questions app is now the native-Relay implementation only (the `confluence_questions_package_
// relay_migration` gate reached 100%, so the Apollo-vs-Relay selector was removed). The paint-lazy
// boundary loads `RelayQuestions` directly; the chunk name is preserved so the paint-optimised
// loading strategy is unchanged.
export const LazyQuestions: LoadableType<QuestionsProps> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Questions" */ './relay/RelayQuestions.tsx'))
			.RelayQuestions,
});
